import React from "react";
import { Phone, MessageSquare, X } from "lucide-react";

const pretty = (n) => (n.startsWith("04") && n.length === 10 ? `${n.slice(0, 4)} ${n.slice(4, 7)} ${n.slice(7)}` : n);

// every number on the client card: tech picks which one to call or text
export default function CallPopup({ numbers, onText, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end" onClick={onClose} data-testid="tech-call-popup">
      <div className="w-full bg-white rounded-t-3xl p-4 pb-[max(env(safe-area-inset-bottom),16px)] space-y-3 max-h-[80dvh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center">
          <div className="flex-1 text-[20px] font-black text-[#0f2f52]">Call or text</div>
          <button onClick={onClose} data-testid="tech-call-close" aria-label="Close" className="h-11 w-11 rounded-xl bg-slate-100 flex items-center justify-center"><X className="h-6 w-6" /></button>
        </div>
        {!numbers.length && <div className="text-[16px] text-slate-500" data-testid="tech-call-none">No phone numbers on this client's card.</div>}
        {numbers.map((n, i) => (
          <div key={n.number} className="rounded-2xl border-2 border-slate-200 p-3 space-y-2" data-testid={`tech-call-row-${i}`}>
            <div className="text-[20px] font-black text-slate-800">{pretty(n.number)} <span className="text-[13px] font-bold text-slate-500">{n.mobile ? "Mobile" : "Phone"}{n.who ? ` · ${n.who}` : ""}</span></div>
            <div className={`grid gap-2 ${n.mobile ? "grid-cols-2" : "grid-cols-1"}`}>
              <a href={`tel:${n.number}`} data-testid={`tech-call-dial-${i}`} className="h-14 rounded-xl bg-green-600 text-white text-[18px] font-black flex items-center justify-center gap-2"><Phone className="h-6 w-6" />Call</a>
              {n.mobile && <button onClick={() => onText(n.number)} data-testid={`tech-call-text-${i}`} className="h-14 rounded-xl bg-cyan-600 text-white text-[18px] font-black flex items-center justify-center gap-2"><MessageSquare className="h-6 w-6" />Text</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
